import { useEffect } from "react";

const Redirector = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
};

export default Redirector;
